var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { observer } from "mobx-react";
import { LazyRender } from "sb-resp-ui";
import Debounce from "debounce-decorator";
import { BetComponents } from "../../../../types";
let BetsChunk = class BetsChunk extends React.Component {
    constructor(props) {
        super(props);
        this.ref = React.createRef();
        this.bindSetBetHeight();
    }
    bindSetBetHeight() {
        let from = this.props.chunkIndex * this.props.chunkSize, to = Math.min((this.props.chunkIndex + 1) * this.props.chunkSize, this.props.displayBets.length);
        for (let i = from; i < to; i++) {
            this.props.displayBets[i].props.setBetHeight = this.adjustHeight.bind(this);
        }
    }
    adjustHeight() {
        if (this.ref.current) {
            this.props.setBetHeight(this.props.chunkIndex, this.ref.current.clientHeight);
        }
    }
    renderBets(from, to) {
        return (React.createElement("div", { ref: this.ref, className: "rj-betting-history__bets-chunk", "data-uat": "betting-history-bets-chunk" }, this.props.displayBets.slice(from, to).map(bet => {
            const Comp = BetComponents[bet.type];
            return React.createElement(Comp, Object.assign({}, bet.props, { key: `bet-${bet.id}` }));
        })));
    }
    render() {
        return (React.createElement(LazyRender, { baseMinHeight: this.props.height, key: `k-lazy-${this.props.chunkIndex}`, observerOptions: {
                threshold: 0,
                rootMargin: "100px 0px"
            } }, this.renderBets(this.props.chunkIndex * this.props.chunkSize, (this.props.chunkIndex + 1) * this.props.chunkSize)));
    }
};
__decorate([
    Debounce(50),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], BetsChunk.prototype, "adjustHeight", null);
BetsChunk = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], BetsChunk);
export { BetsChunk };
//# sourceMappingURL=BetsChunk.js.map